import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import practiceClient from "../../client/PracticeClient";
import useTranslation from "../../hooks/useTranslation";
import LearningProgressNCorrectCard from "../../components/StatusCard/LearningProgressNCorrectCard";
import IncorrectFrequencyNCorrectCard from "../../components/StatusCard/IncorrectFrequencyNCorrectCard";

const StatPage = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const { practiceId } = state || {};
    const navigate = useNavigate();
    const [practice, setPractice] = useState(null);

    useEffect(() => {
        if (practiceId) {
            // Статистика приходит своим эндпоинтом поверх коллекции прогресса.
            // Раньше здесь читался practice.status, которого в ответе API нет и не было:
            // страница рисовала пустые карточки с самого начала.
            practiceClient.getPracticeStats(practiceId)
                .then(setPractice)
                .catch(error => {
                    console.error("Error fetching practice stats:", error);
                });
        }
    }, [practiceId]);

    if (!practice) {
        return <div>{t('practice.run.loading')}</div>;
    }

    return (
        <div style={{ padding: '20px' }}>
            <Button
                type="text"
                icon={<LeftOutlined style={{ fontSize: "10px", marginRight: "8px", marginBottom: "4px" }} />}
                onClick={() => navigate(-1)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "20px",
                    color: "#5b646b",
                    fontSize: "14px"
                }}
            >
                {t('practice.run.back')}
            </Button>

            <div style={{ marginTop: '20px' }}>
                <LearningProgressNCorrectCard
                    items={practice.items}
                    requiredCorrectAnswers={practice.requiredCorrectAnswers}
                    criterion={practice.criterion}
                    practiceId={practice.practiceId}
                    total={practice.total}
                    touched={practice.touched}
                />
            </div>
            <div style={{ marginTop: '20px' }}>
                <IncorrectFrequencyNCorrectCard
                    items={practice.items}
                    requiredCorrectAnswers={practice.requiredCorrectAnswers}
                    criterion={practice.criterion}
                    practiceId={practice.practiceId}
                    total={practice.total}
                    touched={practice.touched}
                />
            </div>
        </div>
    );
};

export default StatPage;
